/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SponsoredRewardResponse } from './SponsoredRewardResponse';
import {
    SponsoredRewardResponseFromJSON,
    SponsoredRewardResponseFromJSONTyped,
    SponsoredRewardResponseToJSON,
    SponsoredRewardResponseToJSONTyped,
} from './SponsoredRewardResponse';
import type { WinnerSummary } from './WinnerSummary';
import {
    WinnerSummaryFromJSON,
    WinnerSummaryFromJSONTyped,
    WinnerSummaryToJSON,
    WinnerSummaryToJSONTyped,
} from './WinnerSummary';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface SponsoredGuildCompetitionWithWinners
 */
export interface SponsoredGuildCompetitionWithWinners {
    /**
     * Mongo id of the competition
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    id: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    sponsorBrandName: string;
    /**
     * Image to display on guild page.
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<SponsoredRewardResponse>}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    rewards: Array<SponsoredRewardResponse>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    runningYear: number;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    brandUrl: string;
    /**
     * BrandActivation shadow record ID
     * @type {string}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    migratedToActivationId?: string;
    /**
     * 
     * @type {Array<WinnerSummary>}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    winnerSummaries?: Array<WinnerSummary>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetitionWithWinners
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the SponsoredGuildCompetitionWithWinners interface.
 */
export function instanceOfSponsoredGuildCompetitionWithWinners(value: object): value is SponsoredGuildCompetitionWithWinners {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sponsorBrandName' in value) || value['sponsorBrandName'] === undefined) return false;
    if (!('promotionImage' in value) || value['promotionImage'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('runningMonth' in value) || value['runningMonth'] === undefined) return false;
    if (!('runningYear' in value) || value['runningYear'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('brandUrl' in value) || value['brandUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SponsoredGuildCompetitionWithWinnersFromJSON(json: any): SponsoredGuildCompetitionWithWinners {
    return SponsoredGuildCompetitionWithWinnersFromJSONTyped(json, false);
}

export function SponsoredGuildCompetitionWithWinnersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredGuildCompetitionWithWinners {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(SponsoredRewardResponseFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'description': json['description'],
        'brandUrl': json['brandUrl'],
        'migratedToActivationId': json['migratedToActivationId'] == null ? undefined : json['migratedToActivationId'],
        'winnerSummaries': json['winnerSummaries'] == null ? undefined : ((json['winnerSummaries'] as Array<any>).map(WinnerSummaryFromJSON)),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function SponsoredGuildCompetitionWithWinnersToJSON(json: any): SponsoredGuildCompetitionWithWinners {
    return SponsoredGuildCompetitionWithWinnersToJSONTyped(json, false);
}

export function SponsoredGuildCompetitionWithWinnersToJSONTyped(value?: SponsoredGuildCompetitionWithWinners | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sponsorBrandName': value['sponsorBrandName'],
        'promotionImage': value['promotionImage'],
        'rewards': ((value['rewards'] as Array<any>).map(SponsoredRewardResponseToJSON)),
        'runningMonth': value['runningMonth'],
        'runningYear': value['runningYear'],
        'description': value['description'],
        'brandUrl': value['brandUrl'],
        'migratedToActivationId': value['migratedToActivationId'],
        'winnerSummaries': value['winnerSummaries'] == null ? undefined : ((value['winnerSummaries'] as Array<any>).map(WinnerSummaryToJSON)),
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

